import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { REPORT_URL } from "../environments/environment";
import { QuoteStatus } from "../types/dai-server/quotes/enums";
import { ResponseQuoteReport } from "../types/dai-server/reports/report-responses";

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    private apiUrl = REPORT_URL;

    constructor(private http: HttpClient) { }

    /** `from` and `to` are yyyy-MM-dd, both days included. No statuses means every status. */
    getQuoteReport(from: string, to: string, statuses: QuoteStatus[]): Observable<ResponseQuoteReport> {
        return this.http.get<ResponseQuoteReport>(`${this.apiUrl}/quotes`, {
            params: { from, to, status: statuses }
        });
    }
}
